export const exampleActions = {
  TEST_EXAMPLE: 'ExampleActions/TEST_EXAMPLE',
};

export function test() {
  return {
    type: exampleActions.TEST_EXAMPLE,
  };
}
